export function transformCurrentSessionSecurity(security,
/**
 * this field is required for the frontend-talent microfrontend to work correctly
 * There is a tech debt in the security graphql schema. These fields must live inside the security.current_session.talent_session
 * TODO: talk with Franco to fix this.
 */
talentSession) {
  var _currentSession$centr, _currentSession$centr2;
  var currentSession = security.current_session;
  return {
    applicationRoles: currentSession.application_roles || [],
    applicationProducts: currentSession.application_products || [],
    applicationPermissions: currentSession.application_permissions || [],
    centralizedSession: {
      centralizedUserId: currentSession.centralized_session.centralized_user_id,
      centralizedOrganizationId: currentSession.centralized_session.centralized_organization_id,
      centralizedOrganizationSlug: currentSession.centralized_session.centralized_organization_slug,
      centralizedUserOrganizationId: currentSession.centralized_session.centralized_user_organization_id,
      centralizedUserOrganizationRole: currentSession.centralized_session.centralized_user_organization_role,
      centralizedUserCountryCode: (_currentSession$centr = currentSession === null || currentSession === void 0 ? void 0 : (_currentSession$centr2 = currentSession.centralized_session) === null || _currentSession$centr2 === void 0 ? void 0 : _currentSession$centr2.centralized_user_country_code) !== null && _currentSession$centr !== void 0 ? _currentSession$centr : undefined
    },
    talentSession: currentSession !== null && currentSession !== void 0 && currentSession.talent_session && talentSession ? {
      companyId: currentSession.talent_session.company_id,
      employeeId: currentSession.talent_session.employee_id,
      userId: currentSession.talent_session.user_id,
      userRole: currentSession.talent_session.user_role,
      flexSidToken: talentSession.flex_sid_token,
      urlParent: talentSession.url_parent,
      userParentId: talentSession.user_parent_id
    } : undefined,
    learningSession: currentSession !== null && currentSession !== void 0 && currentSession.learning_session ? {
      userId: currentSession.learning_session.user_id,
      organizationId: currentSession.learning_session.organization_id,
      organizationSlug: currentSession.learning_session.organization_slug,
      userOrganizationId: currentSession.learning_session.user_organization_id,
      userOrganizationRole: currentSession.learning_session.user_organization_role
    } : undefined
  };
}